import { BaseContainerModel } from "../../base-container.model";
import * as fromDatatype from '../../../datatype-library/index';

export class BinAvailabilityQueryCriteria extends BaseContainerModel {
  location_guids: string[];
  item_guids: string[];
  line_code: fromDatatype.VarcharDatatypeInterface;
  container_measure: fromDatatype.NumericDatatypeInterface;
  job_order_hdr_guids: string[];
  item_status: fromDatatype.VarcharDatatypeInterface;
  item_label_0_guid: fromDatatype.GuidDataFieldInterface;
  item_label_1_guid: fromDatatype.GuidDataFieldInterface;
  item_label_2_guid: fromDatatype.GuidDataFieldInterface;
  item_label_3_guid: fromDatatype.GuidDataFieldInterface;
  item_label_4_guid: fromDatatype.GuidDataFieldInterface;
  item_label_5_guid: fromDatatype.GuidDataFieldInterface;
  item_label_6_guid: fromDatatype.GuidDataFieldInterface;
  item_label_7_guid: fromDatatype.GuidDataFieldInterface;
  item_label_8_guid: fromDatatype.GuidDataFieldInterface;
  item_label_9_guid: fromDatatype.GuidDataFieldInterface;
  item_label_10_guid: fromDatatype.GuidDataFieldInterface;
}